import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-user-circle',
  imports: [],
  templateUrl: './user-circle.html',
  styleUrl: './user-circle.scss',
})
export class UserCircle {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
